export default {
  DISCOUNT_TYPE: {
    PERCENTAGE: {
      value: 1,
      title: '%',
      placeholder: 'Input a percentage of discount',
    },
    IDR: {
      value: 2,
      title: 'IDR',
      placeholder: 'IDR Amount',
    },
  },
};

export const optionsPromo = [
  {
    value: 1,
    label: 'Promotion Offer',
  },
  {
    value: 2,
    label: 'Discount',
  },
];

export const filterSelectedDate = ({ date, teamId }) => {
  return {
    team_id: teamId,
    and: {
      start_date: { lte: `${date.format('YYYY-MM-DD')}T00:00:54Z` },
      end_date: { gte: `${date.format('YYYY-MM-DD')}T23:59:54Z` },
    },
  };
};
export const filterSelectedDateIntegrator = ({ date, teamId }) => {
  return {
    team_id: teamId,
    and: {
      '$ad.start_date$': { lte: `${date.format('YYYY-MM-DD')}T00:00:54Z` },
      '$ad.end_date$': { gte: `${date.format('YYYY-MM-DD')}T23:59:54Z` },
    },
  };
};
